// extracted by mini-css-extract-plugin
module.exports = {"hidden":"chatName_hidden__OjJLE","textEmphasis":"chatName_textEmphasis__2jIrA","nameArea":"chatName_nameArea__DIq7Z","title":"chatName_title__aB5uw","name":"chatName_name__HEVCl"};